import { ArrayField, FormField } from "../../data-model/pharmaPaFormModel";
import { AddMore } from "../../svg/add-more";
import RenderSingleCardForFormConfig from "./renderSingleCardForFormConfig";

const RenderArrayFieldForFormConfig = ({
  field,
  parentKey,
  onAddField,
  onDeleteField,
  onEditField,
}: {
  field: ArrayField;
  parentKey?: string;
  onAddField: (parentKey: string) => void;
  onDeleteField: (key: string) => void;
  onEditField?: (
    parentKey?: string,
    field?: FormField,
    renderIndex?: number,
  ) => void;
}) => {
  const arrayFields = field.fields;

  // Ensure we're working with FormField[][]
  const rows =
    Array.isArray(arrayFields) && arrayFields.length > 0
      ? Array.isArray(arrayFields[0])
        ? arrayFields
        : [arrayFields]
      : [[]];

  return (
    <>
      {rows.map((row, rowIndex) => (
        <div key={`row-${rowIndex}`} className="flex flex-col">
          {row.map((fieldItem, fieldIndex) => (
            <div
              key={fieldItem.key}
              className={`single-row__container ${
                fieldIndex === row.length - 1 ? "mb-0" : "mb-2"
              }`}
            >
              <RenderSingleCardForFormConfig
                field={fieldItem}
                renderIndex={fieldIndex}
                parentKey={parentKey}
                onAddField={onAddField}
                onDeleteField={onDeleteField}
                onEditField={onEditField ?? undefined}
              />
            </div>
          ))}
        </div>
      ))}
      <div
        className="add-button mb-2 ml-2 flex items-center gap-1 text-tiny font-semibold text-tertiaryBlue-4 hover:cursor-pointer hover:text-tertiaryBlue-5"
        onClick={() => {
          onAddField(parentKey ?? "");
        }}
      >
        <AddMore />
        Add Field
      </div>
    </>
  );
};

export default RenderArrayFieldForFormConfig;
